import { useState } from "react";
import { BellRing, Check } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

/** Pulsante di chiamata sul menu pubblico: il cliente chiede aiuto dal tavolo. */
export const ChiamaCameriere = ({ slug, richieste, tavoli }) => {
  const param = new URLSearchParams(window.location.search).get("t") || "";
  const [aperto, setAperto] = useState(false);
  const [tavolo, setTavolo] = useState(param);
  const [esito, setEsito] = useState("");
  const [busy, setBusy] = useState(false);

  const invia = async (tipo) => {
    if (!tavolo) return setEsito("Scegli prima il tuo tavolo.");
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/public/carta/${slug}/chiama`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tavolo, tipo }),
      });
      if (!r.ok) throw new Error();
      const d = await r.json();
      setEsito(d.messaggio || "Richiesta inviata: stiamo arrivando.");
      if (d.ok) setTimeout(() => setAperto(false), 1800);
    } catch {
      setEsito("Non è stato possibile inviare. Chiama a voce il personale.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className="sticky bottom-0 -mx-5 mt-10 border-t border-slate-800 bg-slate-950/95 px-5 py-3 backdrop-blur">
        <button
          data-testid="carta-chiama-btn"
          onClick={() => { setEsito(""); setAperto(true); }}
          className="flex w-full items-center justify-center gap-2 rounded-full bg-amber-400 px-5 py-3.5 text-sm font-bold text-slate-900 transition-transform active:scale-[0.98]"
        >
          <BellRing className="h-4 w-4" /> Chiama il personale
        </button>
      </div>

      {aperto && (
        <div className="fixed inset-0 z-50 flex items-end bg-slate-950/80 p-4 sm:items-center sm:justify-center" data-testid="carta-chiama-dialog">
          <div className="w-full rounded-2xl border border-slate-800 bg-slate-900 p-5 sm:max-w-sm">
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber-400">Di cosa hai bisogno?</p>

            {!param && (
              <div className="mt-4">
                <p className="text-xs text-slate-400">Il tuo tavolo</p>
                {tavoli?.length ? (
                  <select
                    className="mt-1.5 h-11 w-full rounded-lg border border-slate-700 bg-slate-950 px-3 text-sm text-slate-100"
                    value={tavolo}
                    onChange={(e) => setTavolo(e.target.value)}
                    data-testid="carta-tavolo-select"
                  >
                    <option value="">Scegli…</option>
                    {tavoli.map((n) => <option key={n} value={n}>{n}</option>)}
                  </select>
                ) : (
                  <input
                    className="mt-1.5 h-11 w-full rounded-lg border border-slate-700 bg-slate-950 px-3 text-sm text-slate-100"
                    value={tavolo}
                    onChange={(e) => setTavolo(e.target.value)}
                    placeholder="Numero del tavolo"
                    data-testid="carta-tavolo-input"
                  />
                )}
              </div>
            )}

            <div className="mt-4 space-y-2">
              {richieste.map((r) => (
                <button
                  key={r.id}
                  disabled={busy}
                  onClick={() => invia(r.id)}
                  data-testid={`carta-richiesta-${r.id}`}
                  className="w-full rounded-xl border border-slate-700 px-4 py-3 text-left text-sm font-semibold text-slate-100 transition-colors hover:border-amber-400 disabled:opacity-50"
                >
                  {r.label}
                </button>
              ))}
            </div>

            {esito && (
              <p className="mt-4 flex items-center gap-2 text-sm text-emerald-400" data-testid="carta-chiama-esito">
                <Check className="h-4 w-4" /> {esito}
              </p>
            )}

            <button className="mt-5 w-full text-xs text-slate-400" onClick={() => setAperto(false)} data-testid="carta-chiama-close">
              Chiudi
            </button>
          </div>
        </div>
      )}
    </>
  );
};
